module.exports = __webpack_public_path__ + "static/media/bufferLogo.fe295b0d.svg";